"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _superSegments = require("../../reducers/superSegments");

var _actions = require("../../actions");

var _campaignCreator = require("../../actions/campaignCreator");

var _index = require("../../../index");

var _BriefsHelperMessage = _interopRequireDefault(require("../../components/CampaignCreator/BriefsHelperMessage"));

var _BriefsHelperButton = _interopRequireDefault(require("../../components/CampaignCreator/BriefsHelperButton"));

var _LandingPageCard = _interopRequireDefault(require("../../components/CampaignCreator/LandingPageCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GettingStarted = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GettingStarted, _React$Component);

  function GettingStarted() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleHelperVis", function () {
      _this.props.setHelperMessageVisibility('intro', true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleResetSelectedPersonas", function () {
      _this.props.resetSelectedPersonas();
    });

    _defineProperty(_assertThisInitialized(_this), "handleResetSelectedPersonasAndFlow", function () {
      _this.props.resetSelectedPersonas();

      _this.props.setBriefsFlow('find');
    });

    return _this;
  }

  var _proto = GettingStarted.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.loadSuperSegments();
    this.props.featureAccess();
    this.props.loadOptions();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        communityImages = _this$props.communityImages,
        isFetching = _this$props.isFetching,
        firstLandingPage = _this$props.firstLandingPage,
        campaignCreatorAccess = _this$props.campaignCreatorAccess,
        imageOne = _this$props.imageOne,
        imageTwo = _this$props.imageTwo;

    if (isFetching && !communityImages) {
      return /*#__PURE__*/React.createElement(_index.LoadingIndicator, null);
    }

    var HelperMessage = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "Get started by deciding which Helix Personas you\u2019re targeting, either by choosing the \u2018select from the list\u2019 or the \u2018load Helix Personas profile\u2019 option."), /*#__PURE__*/React.createElement("p", null, "Selecting from the list is as easy as clicking on the Personas of interest. However if your customer records are already coded by Helix Personas, or if you subscribe to Roy Morgan Single Source or are using our Live Audience Evaluation platform, we recommend that you select the \u2018load Helix Personas Profile\u2019 option."));
    return /*#__PURE__*/React.createElement(React.Fragment, null, campaignCreatorAccess ? /*#__PURE__*/React.createElement(_semanticUiReact.Container, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "landing-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "landing-page__title-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement("h1", {
      className: "landing-page__title landing-page__title--creative-briefs"
    }, firstLandingPage ? firstLandingPage.pageTitle : null), /*#__PURE__*/React.createElement(_BriefsHelperButton["default"], {
      page: "intro"
    }))), /*#__PURE__*/React.createElement(_BriefsHelperMessage["default"], {
      page: "intro",
      message: HelperMessage
    }), /*#__PURE__*/React.createElement("h3", {
      className: "landing-page__sub-title"
    }, firstLandingPage ? firstLandingPage.subtitle : null), /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      className: "landing-page__inner-grid"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, {
      columns: 2
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/React.createElement(_LandingPageCard["default"], {
      onClickHandler: this.handleResetSelectedPersonas,
      to: "/creative-briefs/select-personas",
      image: imageOne && imageOne,
      introText: firstLandingPage ? firstLandingPage.firstImageIntroText : '',
      title: firstLandingPage ? firstLandingPage.firstImageText : '' // title="I'll select from the list"

    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/React.createElement(_LandingPageCard["default"], {
      onClickHandler: this.handleResetSelectedPersonasAndFlow,
      to: "/creative-briefs/find-personas",
      image: imageTwo && imageTwo,
      introText: firstLandingPage ? firstLandingPage.secondImageIntroText : '',
      title: firstLandingPage ? firstLandingPage.secondImageText : ''
    })))))))) : '');
  };

  return GettingStarted;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    isFetching: state.campaignCreator.options.isFetching,
    communityImages: (0, _superSegments.getCommunityImages)(state),
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    firstLandingPage: state.campaignCreator.options.firstLandingPage,
    helperMessageVisibility: state.campaignCreator.helperMessage.intro // state.campaignCreator &&
    // state.campaignCreator.options &&

  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadOptions: _campaignCreator.loadOptions,
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess,
    setHelperMessageVisibility: _actions.setHelperMessageVisibility,
    resetSelectedPersonas: _actions.resetSelectedPersonas,
    setBriefsFlow: _actions.setBriefsFlow
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GettingStarted);

exports["default"] = _default;